var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEllipse101 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.321,
  d: "M15.644 7.568c0-3.649-3.254-6.607-7.268-6.607S1.108 3.919 1.108 7.568"
})));
export { SvgEllipse101 as ReactComponent };
export default __webpack_public_path__ + "86b84b768afe3cdbae8451b44b54e02b.svg";